module.exports = "/assets/logo_sg_cc_express-c0c93b79c73dad5f04370503c2afbb85.svg";